import { BlockStack, Button, Collapsible, Icon, InlineStack, Tag, Text } from '@shopify/polaris';
import { CancelMajor, ChevronDownMinor, ChevronUpMinor } from '@shopify/polaris-icons';
import React, { useEffect, useState } from 'react';
import { filterSheetProps } from './CustomFilterInterface';
import { useTour } from '../../Components/Other/tour';
import { useTranslation } from 'react-i18next';

const FilterSheet: React.FC<filterSheetProps> = (props: filterSheetProps) => {
    const { t } = useTranslation();

    const { isOpen } = useTour();
    return (
        <div className="FilterSheet bulktour_lisiting_filtersheet">
            <div className={"FilterSheet__header"}>
                <InlineStack align='space-between' blockAlign='center'>
                    <Text as='p' variant='headingLg' fontWeight='bold'>{props.btnText}</Text>
                    <Button onClick={props.handleToggle} icon={CancelMajor} variant='plain' />
                </InlineStack>
            </div>
            <div className="FilterSheet__body" style={{ overflowY: isOpen ? 'hidden' : 'unset' }}>
                {props?.filters?.map((filter: any, index: number) => {


                    return (RenderFilters(filter, index, props, t))
                })}
            </div>
            <div className='FilterSheet__footer'>
                <InlineStack align='space-between' blockAlign='center'>
                    <Button onClick={props.onClearAll}>{props.t("Clear all filters")}</Button>
                    <Button id='filter_sheet_done' variant='primary' onClick={props.handleToggle}>{props.applyBtnText || props.t('Done')}</Button>
                </InlineStack>
            </div>
        </div>
    )
}

const RenderFilters = ({ label, filter, key }: any, index: number, props: filterSheetProps, t: any) => {

    const { appliedFilters } = props;
    const [active, toggle] = useState<boolean>(false);
    useEffect(() => {
        if (sessionStorage?.getItem('start_tour') === 'bulk_upload_2' && key?.toLowerCase() === 'template name') {
            toggle(true)
        }
    }, [])
    return (
        <div className='FilterSheet__BodyAccordian' key={key + index} id={key === "Template name" ? 'bulktour_listing_template' : ""}>
            <BlockStack gap='100'>
                <div className='FilterSheet__BodyAccordian-Header' onClick={() => toggle(!active)}>
                    <BlockStack gap='200'>
                        <InlineStack align='space-between'>
                            <Text as='h2' variant='bodyLg' fontWeight='bold'>{label}</Text>
                            <div>{active ? <Icon source={ChevronUpMinor} /> : <Icon source={ChevronDownMinor} />}</div>
                        </InlineStack>
                        {
                            !active && appliedFilters?.find((filter: any) => filter?.key?.toLowerCase() === key?.toLowerCase()) ?
                                <div><Tag>{appliedFilters?.find((filter: any) => filter?.key?.toLowerCase() === key?.toLowerCase())?.label || "-"}</Tag></div>
                                : <></>
                        }
                    </BlockStack>
                </div>
                <div className='FilterSheet__BodyAccordian-Collapsible'>
                    <Collapsible id="basic-collapsible" open={active} expandOnPrint transition={{ duration: '500ms', timingFunction: 'ease-in-out' }} >
                        <div className='FilterSheet__BodyAccordian-Body'>
                            <BlockStack gap='200' inlineAlign='start'>
                                <div className='FilterSheet__BodyAccordian--filters'>
                                    {filter}
                                </div>
                                <Button
                                    disabled={!(props.appliedFilters?.find((filter: any) => filter?.key?.toLowerCase() === key?.toLowerCase()))}
                                    onClick={() => props.handleRemoveFilter(key)}
                                    variant='plain'
                                    removeUnderline
                                >
                                    {t("Clear")}
                                </Button>
                            </BlockStack>
                        </div>
                    </Collapsible>
                </div>
            </BlockStack>
        </div>
    );
};

export default FilterSheet;